import { render, staticRenderFns } from "./novo-fale-com-a-gente.vue?vue&type=template&id=14b9bd5e&"
import script from "./novo-fale-com-a-gente.vue?vue&type=script&lang=ts&"
export * from "./novo-fale-com-a-gente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14b9bd5e')) {
      api.createRecord('14b9bd5e', component.options)
    } else {
      api.reload('14b9bd5e', component.options)
    }
    module.hot.accept("./novo-fale-com-a-gente.vue?vue&type=template&id=14b9bd5e&", function () {
      api.rerender('14b9bd5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fale-com-a-gente/novo-fale-com-a-gente.vue"
export default component.exports